// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.v-simple-checkbox .theme--light.v-icon[data-v-71282a9f] {\r\n  color: #005eb8 !important;\n}\n.v-simple-checkbox .v-input--selection-controls__input[data-v-71282a9f] {\r\n  margin: 0 !important;\n}\n.v-list--dense .v-subheader[data-v-71282a9f] {\r\n  height: -webkit-fit-content !important;\r\n  height: -moz-fit-content !important;\r\n  height: fit-content !important;\n}\r\n", ""]);
// Exports
module.exports = exports;
